














































import Vue from 'vue'
import dayjs from 'dayjs'
import mixin from'./mixin.vue'
import filePreview from './filePreview.vue'
import { ProductionCraftServiceProxy } from '@/service-proxies/app-v2/product.service-proxies'
import { WorkStationOrderProcessServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'

const productionCraftServiceProxy = new ProductionCraftServiceProxy()
const workStationOrderProcessServiceProxy = new WorkStationOrderProcessServiceProxy()
const columns = [
  {
    title: 'page_resource_pool_action',
    dataIndex: 'action',
    key: 'action',
    width: 180,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'page_my_document_filenm',
    dataIndex: 'fileName',
    key: 'fileName',
    width: 130,
    ellipsis: true
  },
  {
    title: 'page_my_document_type',
    dataIndex: 'fileType',
    key: 'fileType',
    width: 90,
    customRender: text => {
      if (text) {
        return text === 1 ? 'page_my_document_program' : 'page_my_document_process'
      }
    }
  }, {
    title: 'page_my_document_size',
    // dataIndex: 'contentLength',
    dataIndex: 'fileSize',
    key: 'fileSize',
    width: 70,
    customRender: text => {
      let size
      if (text) {
        text = Number(text)
        if (text > 1024 && text < 1048576) {
          size = (text / 1024).toFixed(1) + 'KB'
        } else if (text > 1048576) {
          size = (text / 1048576).toFixed(1) + 'MB'
        } else {
          size = text.toFixed(1) + 'B'
        }
        return size
      }
    }
  },
  {
    title: 'page_business_data_uploaded_by',
    dataIndex: 'uploadName',
    key: 'uploadName',
    width: 110
  },
  {
    title: 'page_transport_directory_upload_time',
    dataIndex: 'updateTime',
    key: 'updateTime',
    width: 135,
    customRender: text => {
      return dayjs(text).format('YYYY-MM-DD HH:mm:ss')
    }
  }
]
export default Vue.extend({
  name: 'fileTable',
  components: {
    filePreview
  },
  mixins: [mixin],
  props: {
    resourceId: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tableLoading: false,
      fileList: [] as any,
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1
      },
      txtBlob: '', // txt文件流
      selectedRowKeys: [],
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        if (item.dataIndex === 'fileType') {
          item.customRender = text => {
            if (text) {
              return text === 1 ? this.$t('page_my_document_program') : this.$t('page_my_document_process')
            }
          }
        }
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  watch: {
    pagination: {
      handler(val) {
        this.pagination.showTotal = (total) => {
          return this.$t('Total…items').replace('{0}', ` ${val.total} `)
        }
      },
      immediate: true
    },
    resourceId: {
      handler(val) {
        this.getFileList()
      },
      immediate: true
    },
    visible: {
      handler(val) {
        if (val) {
          this.getFileList()
        }
      },
      immediate: true
    }
  },
  created() {
    this.pagination.onChange = (currentPage) => {
      this.pagination.current = currentPage
      this.getFileList()
    }
  },
  methods: {
    // 文件列表
    getFileList() {
      // 收起文件详情抽屉，并清空展示的文件详情
      this.showFileInfo = false
      this.fileInfo = {}
      this.fileList = []
      if (!this.resourceId) {
        this.tableLoading = false
        return
      }
      this.tableLoading = true
      workStationOrderProcessServiceProxy.getResourceFileList(this.resourceId).then((res: any) => {
        // console.log('文件列表：', res)
        this.fileList = res
        this.pagination.total = res.length
      }).finally(() => {
        this.tableLoading = false
      })
    },
    // 删除文件
    handleDelete(data: any) {
      productionCraftServiceProxy.deleteFile(data.id).then((res: any) => {
        this.$message.success(this.$t('page_transport_directory_file_deleted_successfully'))
        this.getFileList()
      })
    },
  }
})
